// Theme: neon-grid
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'neon-grid',
  name: 'NEON GRID',
  tagline: 'NEON GRID',
  description: 'Grade neon. Linhas ciano pulsantes sobre escuridao cyberpunk.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0B1020', '#131D35', '#00D4FF', '#CCF6FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-neon-grid'
  },
  colorVars: {
    '--accent': '#00D4FF',
    '--accent-foreground': '#0B1020',
    '--background': '#0B1020',
    '--border': '#2A4A7A',
    '--card': '#131D35',
    '--card-border-active': 'rgba(0, 212, 255, 0.78)',
    '--card-completed': '#11192D',
    '--card-foreground': '#CCF6FF',
    '--card-glow': 'rgba(0, 212, 255, 0.14)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0B1020',
    '--foreground': '#CCF6FF',
    '--hold-fill': '#00D4FF',
    '--input': '#2A4A7A',
    '--modal-bg': '#0B1020',
    '--modal-border': '#2A4A7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#2A4A7A',
    '--muted-foreground': '#CCF6FF',
    '--nav-active': '#00D4FF',
    '--nav-bg': '#131D35',
    '--popover': '#131D35',
    '--popover-foreground': '#CCF6FF',
    '--primary': '#00D4FF',
    '--primary-foreground': '#0B1020',
    '--ring': '#00D4FF',
    '--secondary': '#2A4A7A',
    '--secondary-foreground': '#CCF6FF',
    '--streak': '#00D4FF',
    '--success': '#22c55e',
    '--success-foreground': '#0B1020',
    '--xp': '#00D4FF',
    '--xp-bg': '#131D35'
  },
  resolvedVars: {
    '--accent': '#00D4FF',
    '--accent-foreground': '#0B1020',
    '--accent-foreground-hsl': '226 49% 8%',
    '--accent-foreground-oklch': 'from #0B1020 l c h',
    '--accent-hsl': '190 100% 50%',
    '--accent-oklch': 'from #00D4FF l c h',
    '--background': '#0B1020',
    '--background-hsl': '226 49% 8%',
    '--background-oklch': 'from #0B1020 l c h',
    '--border': '#2A4A7A',
    '--border-hsl': '216 49% 32%',
    '--border-oklch': 'from #2A4A7A l c h',
    '--border-w': '1px',
    '--card': '#131D35',
    '--card-border-active': 'rgba(0, 212, 255, 0.78)',
    '--card-completed': '#11192D',
    '--card-completed-hsl': '223 45% 12%',
    '--card-completed-oklch': 'from #11192D l c h',
    '--card-foreground': '#CCF6FF',
    '--card-foreground-hsl': '191 100% 90%',
    '--card-foreground-oklch': 'from #CCF6FF l c h',
    '--card-glow': 'rgba(0, 212, 255, 0.14)',
    '--card-hsl': '222 47% 14%',
    '--card-oklch': 'from #131D35 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0B1020',
    '--destructive-foreground-hsl': '226 49% 8%',
    '--destructive-foreground-oklch': 'from #0B1020 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#CCF6FF',
    '--foreground-hsl': '191 100% 90%',
    '--foreground-oklch': 'from #CCF6FF l c h',
    '--hold-fill': '#00D4FF',
    '--hold-fill-hsl': '190 100% 50%',
    '--hold-fill-oklch': 'from #00D4FF l c h',
    '--input': '#2A4A7A',
    '--input-hsl': '216 49% 32%',
    '--input-oklch': 'from #2A4A7A l c h',
    '--modal-bg': '#0B1020',
    '--modal-bg-hsl': '226 49% 8%',
    '--modal-bg-oklch': 'from #0B1020 l c h',
    '--modal-border': '#2A4A7A',
    '--modal-border-hsl': '216 49% 32%',
    '--modal-border-oklch': 'from #2A4A7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#2A4A7A',
    '--muted-foreground': '#CCF6FF',
    '--muted-foreground-hsl': '191 100% 90%',
    '--muted-foreground-oklch': 'from #CCF6FF l c h',
    '--muted-hsl': '216 49% 32%',
    '--muted-oklch': 'from #2A4A7A l c h',
    '--nav-active': '#00D4FF',
    '--nav-active-hsl': '190 100% 50%',
    '--nav-active-oklch': 'from #00D4FF l c h',
    '--nav-bg': '#131D35',
    '--nav-bg-hsl': '222 47% 14%',
    '--nav-bg-oklch': 'from #131D35 l c h',
    '--popover': '#131D35',
    '--popover-foreground': '#CCF6FF',
    '--popover-foreground-hsl': '191 100% 90%',
    '--popover-foreground-oklch': 'from #CCF6FF l c h',
    '--popover-hsl': '222 47% 14%',
    '--popover-oklch': 'from #131D35 l c h',
    '--primary': '#00D4FF',
    '--primary-foreground': '#0B1020',
    '--primary-foreground-hsl': '226 49% 8%',
    '--primary-foreground-oklch': 'from #0B1020 l c h',
    '--primary-hsl': '190 100% 50%',
    '--primary-oklch': 'from #00D4FF l c h',
    '--radius': '12px',
    '--ring': '#00D4FF',
    '--ring-hsl': '190 100% 50%',
    '--ring-oklch': 'from #00D4FF l c h',
    '--secondary': '#2A4A7A',
    '--secondary-foreground': '#CCF6FF',
    '--secondary-foreground-hsl': '191 100% 90%',
    '--secondary-foreground-oklch': 'from #CCF6FF l c h',
    '--secondary-hsl': '216 49% 32%',
    '--secondary-oklch': 'from #2A4A7A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#00D4FF',
    '--streak-hsl': '190 100% 50%',
    '--streak-oklch': 'from #00D4FF l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0B1020',
    '--success-foreground-hsl': '226 49% 8%',
    '--success-foreground-oklch': 'from #0B1020 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(190 100% 50% / 0.15)',
    '--xp': '#00D4FF',
    '--xp-bg': '#131D35',
    '--xp-bg-hsl': '222 47% 14%',
    '--xp-bg-oklch': 'from #131D35 l c h',
    '--xp-hsl': '190 100% 50%',
    '--xp-oklch': 'from #00D4FF l c h'
  }
}
